// extracted by mini-css-extract-plugin
export default {"primary":"#a8cc3d","secondary":"#fff","success":"#00b913","error":"#bd0000","warning":"#b99000","info":"#17a2b8","link_color":"#2420d1"};